import { colors, ErrorNote, IconButton, Screen, SectionHeader, Spinner, Text, TopBar, useRouter } from '@khaddi/ui';
import { View } from 'react-native';
import { ProductGrid } from '../components/ProductCard';
import { useTabNav } from '../components/TabNav';
import { useCart } from '../state/cart';
import { useFeatures } from '../state/appConfig';
import { useCatalog } from '../state/catalog';

/** Every drink on the app, grouped under its category in menu order. */
export const MenuScreen = () => {
  const nav = useTabNav('menu');
  const { navigate } = useRouter();
  const { count } = useCart();
  const { onlineOrdering } = useFeatures();
  const { catalog, loading, error, reload, branch } = useCatalog();
  const drinks = (catalog?.drinks ?? []).filter((d) => d.visibleOnApp);
  const groups = (catalog?.categories ?? []).map((c) => ({ category: c, drinks: drinks.filter((d) => d.categoryId === c.id) })).filter((g) => g.drinks.length > 0);

  return (
    <Screen nav={nav}>
      <TopBar title="Thực đơn" background={colors.sky} right={onlineOrdering ? <IconButton icon="bag" label={`Giỏ hàng, ${count} món`} badge={count || null} background={colors.surface} onPress={() => navigate('/checkout')} /> : undefined} />
      {branch ? (
        <Text variant="caption" style={{ paddingHorizontal: 16, paddingTop: 12 }}>
          Giá và món tại {branch.name}
        </Text>
      ) : null}
      {loading ? <Spinner /> : null}
      {error && !catalog ? <ErrorNote message={error} onRetry={() => void reload()} /> : null}
      <View style={{ padding: 16, gap: 20 }}>
        {groups.map((g) => (
          <View key={g.category.id} style={{ gap: 12 }}>
            <SectionHeader title={g.category.name} />
            <ProductGrid products={g.drinks} />
          </View>
        ))}
      </View>
    </Screen>
  );
};
